import React, { FC, useEffect } from 'react';
import { Button, Form, Input, Modal, Space } from 'antd';
import { IModal } from 'common/models/model.interface';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import rentalPropertyService from 'common/services/rental-property-service/rental-property.service';
import { ReactComponent as RejectIcon } from 'assets/icons/reject.svg';
import { notification } from 'common/utils/notification';
import styles from '../rental-portal.module.scss';
import { rejectRentalPropertyValidation } from './reject-rental-property.validation';

const initValues = {
  comment: '',
};

const RejectRentalPropertyModal: FC<IModal<{ rentalPropertyId: number; isApproved: boolean }, any>> = ({
  isOpen,
  onClose,
  title,
  initData,
}) => {
  const [form] = Form.useForm();

  const hideModal = (isSuccess: boolean) => {
    form.resetFields();
    notification.destroy();
    if (onClose) {
      onClose(isSuccess);
    }
  };

  const onFinish = async (values: any) => {
    if (!initData?.rentalPropertyId) {
      console.error('Rental property id is empty');
      return;
    }

    const model = { comment: values.comment };
    if (initData.isApproved) {
      await rentalPropertyService.revoke(initData.rentalPropertyId, model);
    } else {
      await rentalPropertyService.reject(initData.rentalPropertyId, model);
    }
    hideModal(true);
  };

  useEffect(() => {
    if (form && isOpen) {
      form.setFieldsValue(initValues);
    }
  }, [isOpen, form, initData]);

  return (
    <Modal centered title={title} width={750} open={isOpen} wrapClassName="custom-modal" closable={false}>
      <FormWrapper form={form} onFinish={onFinish} initialValues={initValues} layout="vertical">
        <Form.Item name="comment" label="Comment" rules={rejectRentalPropertyValidation.comment}>
          <Input.TextArea rows={4} maxLength={1000} className={styles.modalTextArea} placeholder="Describe the reason for rejection" />
        </Form.Item>
        <Space className="footer">
          <Button type="link" onClick={() => hideModal(false)} className={styles.modalButton}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" icon={<RejectIcon />} className={`${styles.rejectButton} ${styles.modalButton}`} danger>
            Reject
          </Button>
        </Space>
      </FormWrapper>
    </Modal>
  );
};

export default React.memo(RejectRentalPropertyModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});
